import styled from "styled-components";
import logo from './logo.svg';

export const Logo = styled.img.attrs({ src: logo })` 
	position: sticky;
	left: 0;
	height: 100%;
	padding: 8px;
	border-bottom: 1px solid rgba(171, 254, 171, 0.24);
	border-right: 1px solid rgba(171, 254, 171, 0.24);
	background-color: #090908;
	z-index: 10;
	backdrop-filter: blur(8px);
`;
